import React, { Component } from "react";
import Time from "react-time-format";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Breadcrumb from "../../../components/common/breadcrumb";
import { Input, Popover } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import PropertyesList from "../../Propertys_Agent/PropertyesList";
class Asaysh extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenantphone: "",
      ownerPhone: "",
      tenantname: "",
      ownername: "",
      alley: "",
      tenantadress: "",
      NoOfPropert: "",
      ownerSeating: "",
      scuertyName: "",
      tenant_nationality: "",
      save: null,
      property_type: "",
      // old tenant
      oldtenantphone: "",
      oldtenantadress: "",
      oldtenantname: "",
      oldtenant_nationality: "",
      familynumber: "",
    };
  }

  New_Scurity_Page = () => {
    this.setState({
      tenantphone: "",
      ownerPhone: "",
      tenantname: "",
      ownername: "",
      alley: "",
      tenantadress: "",
      NoOfPropert: "",
      ownerSeating: "",
      scuertyName: "",
      save: null,
      oldtenant_nationality: "",
      tenant_nationality: "",
      property_type: "",
      familynumber: "",
    });
  };

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  handleChange_Property = (value) => {
    this.setState({ property_type: value });
  };
  onSave = () => {
    const data = {
      tenantphone: this.state.tenantphone,
      ownerPhone: this.state.ownerPhone,
      tenantname: this.state.tenantname,
      ownername: this.state.ownername,
      alley: this.state.alley,
      tenantadress: this.state.tenantadress,
      NoOfPropert: this.state.NoOfPropert,
      ownerSeating: this.state.ownerSeating,
      scuertyName: this.state.scuertyName,
      oldtenant_nationality: this.state.oldtenant_nationality,
      tenant_nationality: this.state.tenant_nationality,
      oldtenantphone: this.state.oldtenantphone,
      oldtenantadress: this.state.oldtenantadress,
      oldtenantname: this.state.oldtenantname,
      property_type: this.state.property_type,
      familynumber: this.state.familynumber,
    };
    if (
      this.state.ownername === "" ||
      this.state.ownerPhone === "" ||
      this.state.ownerPhone === 0 ||
      this.state.tenantname === "" ||
      this.state.ownername === "" ||
      this.state.scuertyName === ""
    ) {
      Swal.fire({
        title: "OPS",
        text: this.props.change_Lang("Please Check Inputs"),
        icon: "error",
        html: `<b class="fk">${this.props.change_Lang(
          "Please Check Inputs"
        )}</b>`,
        confirmButtonText: this.props.change_Lang("Ok"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1300,
      });
    } else {
      Swal.fire({
        title: "Good job!",
        html: `<b class="fk">${this.props.change_Lang(
          "You successfully tainted your work"
        )}</b>`,
        icon: "success",
        confirmButtonText: this.props.change_Lang("success"),
        buttonsStyling: { fontFamily: "fk" },
        timer: 1000,
      });
      this.props.Create_Asayesh(data);
      this.setState({
        save: true,
      });
    }
  };

  Print = () => {
    window.setTimeout("window.print()", 4000);
  };

  render() {
    const { lang, change_Lang, user } = this.props;
    const {
      tenantphone,
      ownerPhone,
      tenantname,
      ownername,
      tenantadress,
      NoOfPropert,
      ownerSeating,
      save,
      scuertyName,
      oldtenant_nationality,
      tenant_nationality,
      oldtenantname,
      oldtenantadress,
      oldtenantphone,
      property_type,
      familynumber,
    } = this.state;
    const { handleChange, Print, handleChange_Property } = this;
    return (
      <>
        <Breadcrumb
          title={change_Lang("Sceurity Anket")}
          parent={change_Lang("s_dashboard")}
        />
        <div
          className={`${
            lang === "en" ? "container-fluid" : "container-fluid fk"
          }`}
        >
          <p
            style={{
              fontSize: "20px",
              color: "black",
              background: "white",
            }}
            className="mb-4 d-lg-none d-sm-flex justify-content-sm-start text-center text-uppercase p-1"
          >
            {change_Lang("Sceurity Anket")}
          </p>
          <div className="row">
            <div className="col-12">
              <div
                className="card product-page-main card-body"
                style={{ background: "#e3e9f2" }}
              >
                <div className="card-body p-0">
                  <div className="row">
                    <div className="col-md-1 text-right ">
                      <p
                        style={{
                          fontSize: "18px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                        className="mb-1 d-flex justify-content-start"
                      >
                        {change_Lang("to")}:
                      </p>
                    </div>
                    <div className="col-md-3 text-right ">
                      <Input
                        type="text"
                        className={`${
                          lang === "en"
                            ? "form-control text-center"
                            : "form-control text-center fk"
                        }`}
                        value={scuertyName}
                        name="scuertyName"
                        size="middle"
                        onChange={handleChange}
                        disabled={save === true ? true : null}
                        autoComplete="off"
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {
                                      "ئایا ئە ئەنکێتە بۆ ئاسایشە یاخود بۆ پڕۆژەیە داخڵ بکە"
                                    }
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : ئاسایشی ______
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>
                    <div className="col-sm-4"></div>
                    <div className="col-sm-1">
                      <p
                        style={{
                          fontSize: "18px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                        className="mb-1 d-flex justify-content-start"
                      >
                        {change_Lang("date")}:
                      </p>
                    </div>
                    <div className="col-sm-3">
                      <Time
                        value={Date.now()}
                        format="YYYY-MM-DD"
                        className={`${
                          lang === "en"
                            ? "form-control text-center"
                            : "form-control text-center fk"
                        }`}
                        style={{
                          fontSize: "18px",
                          color: "blck",
                        }}
                        // className="form-control col-sm-12 text-center py-0"
                      />
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-md-12">
                      <p
                        style={{
                          fontSize: "20px",
                          color: "black",
                          background: "white",
                          borderRadius: "10px",
                        }}
                        className="mb-4 d-none d-lg-flex justify-content-center text-uppercase p-1"
                      >
                        {change_Lang("Sceurity Anket")}
                      </p>
                    </div>
                  </div>
                  <div className="row d-flex justify-content-center">
                    <div className="form-group input-container col-md-3">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp; {change_Lang("Former tenant's name")}
                      </label>
                      <Input
                        size="middle"
                        value={oldtenantname}
                        name="oldtenantname"
                        onChange={handleChange}
                        type="text"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"ناوی کرێچی پێشوو داخڵ بکە"}
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : محمد عبداللە عمر
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>

                    <div className="form-group input-container col-md-3">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp; {change_Lang("Where to go")}
                      </label>
                      <Input
                        size="middle"
                        value={oldtenantadress}
                        name="oldtenantadress"
                        onChange={handleChange}
                        type="text"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {
                                      "شوێنی ڕۆیشتنی کرێچی پێشوو واتا شوێنی ئەو موڵکەی لێ نیشتەجێبوو داخڵ بکە"
                                    }
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : ستار تاوەر
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>

                    <div className="form-group input-container col-md-3">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp;{change_Lang("Nation")}
                      </label>
                      <Input
                        size="middle"
                        value={oldtenant_nationality}
                        name="oldtenant_nationality"
                        onChange={handleChange}
                        type="text"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"نەتەوەی کرێچی پێشوو داخڵ بکە"}
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : کورد
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>

                    <div className="form-group input-container col-md-3">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp;
                        {change_Lang("invoice_mob")}
                      </label>
                      <Input
                        size="middle"
                        value={oldtenantphone}
                        name="oldtenantphone"
                        onChange={handleChange}
                        type="number"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"ژمارەی مۆبایلی کرێچی پێشوو داخڵ بکە"}
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : 075075075075
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>
                  </div>
                  {/* Amanj 2*/}
                  <div className="row d-flex justify-content-center">
                    <div className="form-group input-container col-md-3">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp; {change_Lang("Current tenant")}
                      </label>
                      <Input
                        size="middle"
                        value={tenantname}
                        name="tenantname"
                        onChange={handleChange}
                        type="text"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {
                                      "ناوی کرێچی ئێستا کە موڵکەکەی بە کرێگرتووە داخڵ بکە"
                                    }
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : محمد عبداللە عمر
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>

                    <div className="form-group input-container col-md-3">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp; {change_Lang("where they came")}
                      </label>
                      <Input
                        size="middle"
                        value={tenantadress}
                        name="tenantadress"
                        onChange={handleChange}
                        type="text"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"شوێنی هاتنی کرێچی ئێستا داخڵ بکە"}
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : ستار تاوەر
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>

                    <div className="form-group input-container col-md-2">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp; {change_Lang("Nation")}
                      </label>
                      <Input
                        size="middle"
                        value={tenant_nationality}
                        name="tenant_nationality"
                        onChange={handleChange}
                        type="text"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"نەتەوەی کرێچی ئێستا داخڵ بکە"}
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : کورد
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>

                    <div className="form-group input-container col-md-2">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp;
                        {change_Lang("invoice_mob")}
                      </label>
                      <Input
                        size="middle"
                        value={tenantphone}
                        name="tenantphone"
                        onChange={handleChange}
                        type="number"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {
                                      "ژمارەی مۆبایلی کرێچی ئێستا داخڵ بکە تەنها ژمارەی ئینگلیزی"
                                    }
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : 075075075075
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>
                    <div className="form-group input-container col-md-2">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp;{change_Lang("Number of family members_")}
                      </label>
                      <Input
                        size="middle"
                        value={familynumber}
                        name="familynumber"
                        onChange={handleChange}
                        type="number"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {
                                      "ژمارەی ئەندامەکانی کرێچی ئێستا داخڵ بکە تەنها ژمارەی ئینگلیزی"
                                    }
                                  </span>
                                  <br />
                                  <span className="text-center">نمونە : 5</span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>
                  </div>
                  {/* ayat */}
                  <div className="row d-flex justify-content-center">
                    <div className="form-group input-container col-md-3">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp; {change_Lang("Owner Name")}
                      </label>
                      <Input
                        size="middle"
                        value={ownername}
                        name="ownername"
                        onChange={handleChange}
                        type="text"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"ناوی خاوەن موڵک داخڵ بکە بەم شێوەیە"}
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : محمد عبداللە عمر
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>
                    <div className="form-group input-container col-md-2">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp; {change_Lang("Type of property")}
                      </label>
                      <PropertyesList
                        onChangeProperty={handleChange_Property}
                        valueOption={property_type}
                        size="middle"
                        style={{
                          fontSize: "16px",
                        }}
                      />
                    </div>
                    <div className="form-group input-container col-md-2">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp; {change_Lang("Property Address")}
                      </label>
                      <Input
                        size="middle"
                        value={ownerSeating}
                        name="ownerSeating"
                        onChange={handleChange}
                        type="text"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {"ناونیشانی موڵکەکە داخڵ بکە"}
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : ستار تاوەر
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>
                    <div className="form-group input-container col-md-3">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp; {change_Lang("Number of property")}
                      </label>
                      <Input
                        size="middle"
                        value={NoOfPropert}
                        name="NoOfPropert"
                        onChange={handleChange}
                        type="text"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {
                                      "ژمارەی کارەبای موڵك یاخود ژمارەی موڵکەکە داخڵ بکە"
                                    }
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : 45/12/25
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>
                    <div className="form-group input-container col-md-2">
                      <label
                        className="col-form-label fk d-flex justify-content-center"
                        style={{
                          fontSize: "16px",
                          color: "#000",
                          fontWeight: "bold",
                        }}
                      >
                        <span style={{ color: "#000" }}>*</span>
                        &nbsp;
                        {change_Lang("invoice_mob")}
                      </label>
                      <Input
                        size="middle"
                        value={ownerPhone}
                        name="ownerPhone"
                        onChange={handleChange}
                        type="number"
                        style={{
                          fontSize: "16px",
                          borderBottomColor: "#000",
                        }}
                        addonBefore={
                          <>
                            <Popover
                              content={
                                <div className="text-center">
                                  <span
                                    className="fk"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {
                                      "ژمارەی مۆبایلی خاوەن موڵک داخڵ بکە تەنها ژمارەی ئینگلیزی داخڵ بکە"
                                    }
                                  </span>
                                  <br />
                                  <span className="text-center">
                                    نمونە : 075075075075
                                  </span>
                                </div>
                              }
                            >
                              <FaInfoCircle
                                style={{
                                  justifyContent: "center",
                                  alignItems: "center",
                                  display: "flex",
                                  color: "#000",
                                  fontWeight: "bolder",
                                }}
                                size={15}
                              />
                            </Popover>
                          </>
                        }
                      />
                    </div>
                  </div>

                  <br />
                  {user && user.c_scurety !== false ? (
                    <div className="row">
                      <div className="col-lg-3"></div>
                      <div className="col-12 col-lg-6">
                        {save === null ? (
                          <>
                            <button
                              className="btn btn-sm"
                              onClick={() => {
                                this.onSave();
                                this.props.Get_List_Scurety_Bills();
                              }}
                              style={{
                                color: "white",
                                background: "#274bbd",
                              }}
                            >
                              <span
                                className="d-none d-lg-inline"
                                style={{ color: "white", fontSize: "12px" }}
                              >
                                {" "}
                                {change_Lang("save")}
                              </span>
                            </button>
                            &nbsp;&nbsp;&nbsp;
                            <button
                              className="btn mx-5"
                              style={{
                                background: "#7F8C8D",
                                color: "white",
                              }}
                              onClick={this.New_Scurity_Page}
                            >
                              <span
                                className="d-none d-lg-inline"
                                style={{ color: "white", fontSize: "12px" }}
                              >
                                {" "}
                                {change_Lang("new_page")}
                              </span>
                            </button>
                          </>
                        ) : (
                          <>
                            <Link to="/print_Asaysh" onClick={Print}>
                              <button className="btn btn-primary">
                                <span
                                  className="d-none d-lg-inline"
                                  style={{ color: "white", fontSize: "12px" }}
                                >
                                  {" "}
                                  {change_Lang("Print")}
                                </span>
                              </button>
                            </Link>
                          </>
                        )}
                      </div>
                      <div className="col-lg-3"></div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Asaysh;
